import React, { useEffect, useState } from 'react'

import Tag from './Tag'

const defaultSeprators = ['Enter']

const TagsInput = ({
  placeHolder,
  tagsList,
  onChange,
  onExisting,
  onRemoved,
  disabled,
  isEditOnRemove,
  beforeAddValidate,
  containerStyle = {},
}) => {
  const [tags, setTags] = useState([...new Set(tagsList)] || [])
  const [inputValue, setInputValue] = useState('')
  useEffect(() => {
    onChange && onChange(tags)
  }, [tags])

  const handleOnKeyUp = (e) => {
    e.stopPropagation()
    const text = e.target.value
    setInputValue(text)

    if (e.key === 'Backspace' && tags.length && !text) {
      e.target.value = isEditOnRemove ? `${tags.at(-1)} ` : ''
      setTags([...tags.slice(0, -1)])
    }

    if (text && defaultSeprators.includes(e.key)) {
      if (beforeAddValidate && !beforeAddValidate(text, tags)) return

      if (tags.includes(text)) {
        onExisting && onExisting(text)
        return
      }
      setTags([text, ...tags])
      e.target.value = ''
      setInputValue('')
      e.preventDefault()
    }
  }

  const onTagRemove = (text) => {
    setTags(tags.filter((tag) => tag !== text))
    onRemoved && onRemoved(text)
  }

  return (
    <div
      className="rounded-3xl border overflow-x-hidden md:overflow-x-auto border-solid border-[#d4d4d4] h-[150px] md:h-[96px] relative  overflow-y-auto md:w-auto w-full md:min-h-[140px] p-3"
      style={containerStyle}
    >
      {tags.map((tag) => (
        <Tag key={tag} text={tag} remove={onTagRemove} disabled={disabled} />
      ))}
      <div className="flex justify-start items-center">
        <input
          style={{
            width: `${0.6 * inputValue.length}vw`,
            minWidth: 300,
          }}
          placeholder={placeHolder}
          onKeyDown={handleOnKeyUp}
          className="m-auto md:m-[1px] min-w-[170px] p-2 rounded-2xl w-[400px] text-black mr-2.5 focus:text-left focus:pl-2.5"
        />
      </div>
    </div>
  )
}

export default TagsInput
